module.exports = __webpack_public_path__ + "static/media/galerija_2021 (9).29e9626c.jpg";